import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getCardiacSelector } from '../../procedures/cardiac/selectors'
import { ICardiacState } from '../../procedures/cardiac/store/cardiac.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { getCardiacFilters } from '../../procedures/cardiac/utilities/saveCardiac.util'

export function* addCardiacItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const { items } = timeline
  const cardiacState: ICardiacState = yield select(getCardiacSelector)
  const {
    pta,
    addToTimeline,
    action,
    joules,
    defibType,
    waveformType,
    leadChange,
    key,
    time,
    date,
    assessedBy,
    successfulAttempt,
    comments,
    isEkgImport,
  } = cardiacState
  const clientCorrelationId = generateClientCorrelationId(
    nemsisCodeOptions,
    TimelineConstants.CARDIAC_PROCEDURE,
    action?.name || '',
    {
      filter1: getCardiacFilters(cardiacState).filter1Field,
      filter2: getCardiacFilters(cardiacState).filter2Field,
      filter3: getCardiacFilters(cardiacState).filter3Field,
    },
    key
  )
  if (addToTimeline) {
    const showJoules = action?.name === 'Defibrillation' ? true : false
    const showDefibType = action?.name === 'Defibrillation' ? true : false
    const showWaveformType = action?.name === 'Defibrillation' ? true : false
    const showLeadChange = action?.name === '12-Lead EKG' ? true : false
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Cardiac',
      eventSubHeader: `By ${assessedBy?.name || ''}, Action: ${action?.name || ''}, ${
        showJoules ? 'Joules: ' + joules + ', ' : ''
      }
      ${showDefibType ? 'Defib Type: ' + (defibType?.name || '') + ', ' : ''}
      ${showWaveformType ? 'Type: ' + (waveformType?.name || '') + ', ' : ''}
      ${showLeadChange ? 'Lead Change: ' + leadChange.map((o) => o.name) + ', ' : ''}
      Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_CARDIAC_PROCEDURE_ITEM,
      defaultHref: TabConstants.CARDIAC_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addCardiacItemSaga() {
  yield takeLatest([TimelineConstants.ADD_CARDIAC_ITEM], addCardiacItem)
}
